import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/auth/login", { username, password });
      localStorage.setItem("admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white/[0.04] border border-white/10 rounded-2xl p-8 backdrop-blur">
        <div className="flex items-center gap-2 mb-6">
          <img src="/penz-icon.png" alt="PENZ" className="w-9 h-9 rounded-lg bg-white/10 p-1 object-contain" />
          <div>
            <div className="font-display font-semibold">PENZ Yönetici</div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-white/50">Sistem Girişi</div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs text-white/70">Kullanıcı Adı</Label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="h-10 bg-white/5 border-white/15 text-white rounded-lg"
              autoComplete="username"
              autoFocus
              required
              data-testid="admin-login-username"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs text-white/70">Şifre</Label>
            <div className="relative">
              <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? "text" : "password"}
                className="h-10 bg-white/5 border-white/15 text-white rounded-lg pr-10"
                autoComplete="current-password"
                required
                data-testid="admin-login-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                aria-pressed={showPassword}
                tabIndex={-1}
                className="absolute inset-y-0 right-0 flex items-center px-3 text-white/60 hover:text-white focus:outline-none"
                data-testid="admin-login-password-toggle"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <Button
            type="submit"
            className="w-full bg-white text-slate-900 hover:bg-slate-100 h-10 rounded-lg"
            disabled={loading}
            data-testid="admin-login-submit"
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>
        </form>
        <div className="mt-4 text-center">
          <a
            href="/admin/sifremi-unuttum"
            className="text-xs text-white/60 hover:text-white"
            data-testid="admin-login-forgot-password-link"
          >
            Şifremi Unuttum
          </a>
        </div>
      </div>
    </div>
  );
}
